import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  loginViaGoogle,
  loginViaFacebook,
  authStatusSelector,
  loginErrorSelector,
  networkStatusSelector,
} from '../../../reducers';
import Login from './component';

const mapStateToProps = (state) => {
  return {
    authenticated: authStatusSelector(state),
    loginError: loginErrorSelector(state),
    networkStatus: networkStatusSelector(state),
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    loginViaGoogle,
    loginViaFacebook,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/component/organisms/Login/index.js